import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import { localize } from 'helpers/translator'
import styles from './toggle.scss'

const Toggle = props => {
	const value = props.value

	return <div styleName={classNames({
		toggler: true,
		off: value === '0',
		on: value === '1',
	})}
	onClick={() => props.onChange(value === '1' ? '0':'1')}>
		<span styleName='toggler-off-label'>
			{props.shouldShowText &&
				localize('toggle_label_off')
			}
		</span>
		<div styleName='toggler-bar'>
			<span styleName='toggler-on-label'>
				{props.shouldShowText &&
					localize('toggle_label_on')
				}
			</span>
			<div styleName='toggler-circle'>
			</div>
		</div>
	</div>
}

Toggle.propTypes = {
	onChange: PropTypes.func,
	value: PropTypes.oneOf(['0', '1']),
	shouldShowText: PropTypes.bool,
}

Toggle.defaultProps = {
	onChange: () => {},
	value: '0',
	shouldShowText: true,
}

export default CSSModules(Toggle, styles, {allowMultiple: true})
